/**
 * Theme customization constants and utilities
 * 
 * This module exports reusable theme values to avoid hardcoding
 * colors, spacing, and other design tokens throughout the app.
 */

import { shapes } from '@backstage/theme';

/**
 * Verint brand colors used across themes
 */
export const brandColors = {
  primary: '#0078d4',
  primaryDark: '#005a9e',
} as const;

/**
 * Page theme configurations for different page types
 */
export const pageThemeConfig = {
  colors: [brandColors.primary, brandColors.primaryDark] as string[],
  shapes: {
    wave: shapes.wave,
    round: shapes.round,
  },
} as const;
